import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import withStyles from "@material-ui/styles/withStyles";
import {
  AppBar,
  Toolbar,
  Typography,
  Drawer,
  IconButton,
  ClickAwayListener,
  Hidden,
  LinearProgress,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";

import {
  logout,
  selectUserDetails,
} from "../../../features/authentication/authenticationSlice";
import { selectSelectedProject } from "../../../features/authentication/authenticationSlice";

import { selectLoader as selectStructureLoader } from "../../../features/structure/structureSlice";

import styles from "./Navigation.styles";
import AccountMenu from "./AccountMenu";
import Sidebar from "./Sidebar";
import SnackBar from "./SnackBar";

function Navigation({ classes, title, children }) {
  const structureLoader = useSelector(selectStructureLoader);
  const userDetails = useSelector(selectUserDetails);
  const selectedProject = useSelector(selectSelectedProject);
  const dispatch = useDispatch();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const uiDrawerContent = (
    <div className={classes.drawerMenu}>
      <div className={classes.spacer} />
      <Sidebar onSelect={() => setDrawerOpen(false)} />
    </div>
  );

  return (
    <ClickAwayListener onClickAway={() => setDrawerOpen(false)}>
      <div className={classes.root}>
        <AppBar position="fixed" color="secondary" className={classes.appBar}>
          {structureLoader && <LinearProgress className={classes.loader} />}
          <Toolbar>
            <Hidden smUp>
              <IconButton
                color="inherit"
                edge="start"
                onClick={() => setDrawerOpen(!drawerOpen)}
              >
                <MenuIcon />
              </IconButton>
            </Hidden>
            <img src="/logo.svg" className={classes.logo} alt="logo" />
            <Hidden xsDown>
              <Typography variant="h6" className={classes.title}>
                {selectedProject?.name + " - " + title}
              </Typography>
            </Hidden>
            <AccountMenu
              classes={classes}
              userDetails={userDetails}
              onLogout={() => dispatch(logout())}
            />
          </Toolbar>
        </AppBar>
        <Hidden xsDown>
          <Drawer
            variant="persistent"
            anchor="left"
            open={true}
            className={classes.drawer}
          >
            {uiDrawerContent}
          </Drawer>
        </Hidden>
        <Hidden smUp>
          <Drawer
            anchor="left"
            open={drawerOpen}
            className={classes.drawer}
            onClose={() => setDrawerOpen(false)}
          >
            {uiDrawerContent}
          </Drawer>
        </Hidden>
        <div className={classes.content}>
          <div className={classes.spacer} />
          {children}
          <SnackBar />
        </div>
      </div>
    </ClickAwayListener>
  );
}

export default withStyles(styles)(Navigation);
